import { addMessages } from '@hana/i18n';

// Khoá chuỗi của HANA Mov (app tài xế). Mã nghiệp vụ, biển số, tên riêng và dữ liệu không dịch.
addMessages('vi', {
});
addMessages('en', {
});

addMessages('vi', {
  'mov.ph.back': 'Quay lại chi tiết chuyến',
  'mov.ph.title': 'Chụp ảnh',
  'mov.ph.sub': 'TRF2610078 · 1×40RF · yêu cầu −18°C',
  'mov.ph.kind': 'Loại ảnh',
  'mov.ph.offline': 'Ngoại tuyến.',
  'mov.ph.offlineDesc': 'Ảnh lưu trên máy kèm giờ và vị trí, tự gửi khi có sóng.',
  'mov.ph.noCam': 'Chưa mở quyền camera',
  'mov.ph.noCamDesc': 'Cho phép HANA Mov dùng camera và vị trí trong Cài đặt của máy, rồi mở lại.',
  'mov.ph.none': 'Không có ảnh cần chụp',
  'mov.ph.noneDesc': 'Bước hiện tại không yêu cầu ảnh. Ảnh bắt buộc sẽ hiện ở đây khi tới bước.',
  'mov.ph.stamp': 'Dấu đóng lên ảnh',
  'mov.ph.sharp': 'Nét',
  'mov.ph.light': 'Sáng',
  'mov.ph.edge': 'Đủ 4 góc',
  'mov.ph.sim': 'Mô phỏng chất lượng ảnh (chỉ trên bản thiết kế)',
  'mov.ph.receiver': 'Tên người nhận ký trên biên bản (bắt buộc)',
  'mov.ph.receiverPh': 'VD: Nguyễn Thị Lan — thủ kho',
  'mov.ph.library': 'Chọn ảnh có sẵn',
  'mov.ph.libraryToast': 'Ảnh chọn từ thư viện vẫn qua kiểm mờ/tối/góc',
  'mov.ph.shoot': 'Chụp',
  'mov.ph.taken': '{n} ảnh đã chụp',
  'mov.ph.delete': 'Xoá ảnh {k}',
  'mov.ph.deleted': 'Đã xoá ảnh',
  'mov.ph.ptiSent': 'PTI hôm nay đã gửi lúc {hm}. Gửi lại nếu phát hiện lỗi mới.',
  'mov.ph.ptiNeed': 'PTI bắt buộc trước chuyến đầu ngày. Chưa gửi PTI thì chưa bấm được "Bắt đầu chuyến".',
  'mov.ph.ok': 'Đạt',
  'mov.ph.bad': 'Có lỗi',
  'mov.ph.defectSaved': 'Ảnh lỗi đạt · đã lưu',
  'mov.ph.defectRetake': 'Đã chụp ảnh lỗi · chụp lại',
  'mov.ph.defectTake': 'Chụp ảnh lỗi (bắt buộc)',
  'mov.ph.missing': 'Còn {n} mục chưa kiểm',
  'mov.ph.noPhoto': '{n} lỗi chưa có ảnh',
  'mov.ph.sendPti': 'Gửi PTI',
  'mov.ph.accepted': 'Ảnh đạt · đã lưu',
  'mov.ph.needReceiver': 'Nhập tên người nhận ký trước khi gửi',
  'mov.ph.noGood': 'Chưa có ảnh đạt để gửi',
  'mov.ph.savedOffline': 'Đã lưu {n} ảnh trên máy · tự gửi khi có sóng',
  'mov.ph.sentJob': 'Đã gửi {n} ảnh {name} vào job HANA-SE-2610-0133',
  'mov.ph.ptiToast': 'Đã gửi PTI xe',
});
addMessages('en', {
  'mov.ph.back': 'Back to trip detail',
  'mov.ph.title': 'Take photos',
  'mov.ph.sub': 'TRF2610078 · 1×40RF · requires −18°C',
  'mov.ph.kind': 'Photo type',
  'mov.ph.offline': 'Offline.',
  'mov.ph.offlineDesc': 'Photos are saved on the device with time and location and sent when back online.',
  'mov.ph.noCam': 'Camera permission not granted',
  'mov.ph.noCamDesc': 'Allow HANA Mov to use the camera and location in device Settings, then reopen.',
  'mov.ph.none': 'No photos required',
  'mov.ph.noneDesc': 'The current step needs no photo. Required photos appear here when you reach the step.',
  'mov.ph.stamp': 'Stamp on photo',
  'mov.ph.sharp': 'Sharp',
  'mov.ph.light': 'Bright',
  'mov.ph.edge': 'All 4 corners',
  'mov.ph.sim': 'Photo quality simulation (design build only)',
  'mov.ph.receiver': 'Receiver name on the record (required)',
  'mov.ph.receiverPh': 'E.g. Nguyen Thi Lan — storekeeper',
  'mov.ph.library': 'Choose existing photo',
  'mov.ph.libraryToast': 'Library photos still go through the blur/dark/corner check',
  'mov.ph.shoot': 'Shoot',
  'mov.ph.taken': '{n} photos taken',
  'mov.ph.delete': 'Delete photo {k}',
  'mov.ph.deleted': 'Photo deleted',
  'mov.ph.ptiSent': "Today's PTI was sent at {hm}. Resend if you find a new defect.",
  'mov.ph.ptiNeed': 'PTI is required before the first trip of the day. Until it is sent, "Start trip" is locked.',
  'mov.ph.ok': 'Pass',
  'mov.ph.bad': 'Defect',
  'mov.ph.defectSaved': 'Defect photo accepted · saved',
  'mov.ph.defectRetake': 'Defect photo taken · retake',
  'mov.ph.defectTake': 'Take defect photo (required)',
  'mov.ph.missing': '{n} items not checked',
  'mov.ph.noPhoto': '{n} defects without photo',
  'mov.ph.sendPti': 'Send PTI',
  'mov.ph.accepted': 'Photo accepted · saved',
  'mov.ph.needReceiver': 'Enter the receiver name before sending',
  'mov.ph.noGood': 'No accepted photo to send',
  'mov.ph.savedOffline': 'Saved {n} photos on device · sent when back online',
  'mov.ph.sentJob': 'Sent {n} {name} photos to job HANA-SE-2610-0133',
  'mov.ph.ptiToast': 'Vehicle PTI sent',
});
